import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";
import { useLang } from "@/contexts/LangContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function Register() {
  const { register } = useAuth();
  const { t } = useLang();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await register(email, password, name);
      navigate("/cuenta", { replace: true });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
      setSubmitting(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 md:px-12 py-24 fade-in" data-testid="register-page">
      <p className="tracking-eyebrow text-[var(--eafg-muted)]">{t("auth.registerSubtitle")}</p>
      <h1 className="font-serif-display text-5xl mt-3 mb-10">{t("auth.registerTitle")}</h1>

      <form onSubmit={submit} className="space-y-6" data-testid="register-form">
        <label className="block">
          <span className="tracking-eyebrow text-[var(--eafg-muted)] block mb-2">{t("auth.name")}</span>
          <input
            type="text"
            required
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-full border-b border-[var(--eafg-line)] bg-transparent py-2 focus:outline-none focus:border-[var(--eafg-ink)]"
            data-testid="register-name"
          />
        </label>
        <label className="block">
          <span className="tracking-eyebrow text-[var(--eafg-muted)] block mb-2">{t("auth.email")}</span>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full border-b border-[var(--eafg-line)] bg-transparent py-2 focus:outline-none focus:border-[var(--eafg-ink)]"
            data-testid="register-email"
          />
        </label>
        <label className="block">
          <span className="tracking-eyebrow text-[var(--eafg-muted)] block mb-2">
            {t("auth.password")}
          </span>
          <input
            type="password"
            required
            minLength={8}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full border-b border-[var(--eafg-line)] bg-transparent py-2 focus:outline-none focus:border-[var(--eafg-ink)]"
            data-testid="register-password"
          />
        </label>
        <button
          type="submit"
          disabled={submitting}
          className="w-full bg-[var(--eafg-ink)] text-white py-4 tracking-eyebrow hover:bg-[var(--eafg-copper)] transition-colors disabled:opacity-50"
          data-testid="register-submit"
        >
          {t("auth.submitRegister")}
        </button>
        <p className="text-sm text-[var(--eafg-muted)]">
          {t("auth.hasAccount")}{" "}
          <Link to="/login" className="underline hover:text-[var(--eafg-copper)]">
            {t("auth.submitLogin")}
          </Link>
        </p>
      </form>
    </div>
  );
}
